import { RootState } from 'store/rootReducer';

export const AddressSectionContentSelector = (state: RootState) => state.content.addressSection;
